import React from 'react';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { HStack } from '@televet/kibble-ui/build/chakra';

interface IChannelListFilterPopoverHeader {
  iconFirst: boolean;
  isClearButtonDisabled: boolean;
  onHandleSaveFilterButtonClick: () => void;
  onClearButtonClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}
const ChannelListFilterPopoverHeader = ({
  iconFirst,
  isClearButtonDisabled,
  onHandleSaveFilterButtonClick,
  onClearButtonClick,
}: IChannelListFilterPopoverHeader): JSX.Element => {
  return (
    <>
      {iconFirst ? (
        <HStack onClick={onHandleSaveFilterButtonClick}>
          <Button
            data-testid="channel-list-popover-header-Saved-Filters"
            variant="ghostNeutral"
            size="md"
            aria-label="Go back"
            iconName="chevronLeft"
          />
          <Heading cursor="pointer" size="md" fontWeight="bold">
            Saved Filters
          </Heading>
        </HStack>
      ) : (
        <Button
          data-testid="channel-list-popover-header-Saved-Filters"
          variant="ghostNeutral"
          size="sm"
          iconName="bookmark"
          onClick={onHandleSaveFilterButtonClick}
        >
          Saved Filters
        </Button>
      )}
      <Button
        data-testid="channel-list-popover-header-Clear-Filters"
        variant="ghostNeutral"
        size="sm"
        isDisabled={isClearButtonDisabled}
        iconName="arrowCircle"
        onClick={onClearButtonClick}
      >
        Clear
      </Button>
    </>
  );
};

export default ChannelListFilterPopoverHeader;
